import React from 'react';
import { Container, Wrapper } from './styles.Paper';
import { Note } from '../../../styles/styledComponents';

interface Props {
    signature?: string;
}

export const Paper: React.FC<Props> = ({ children, signature }) => {
    return (
        <Container>
            <Wrapper>{children}</Wrapper>
            <Note>{signature}</Note>
        </Container>
    );
};
